<style lang="less" scoped>
  @import './base.less';

  .header {
    height: 2.2rem;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: .5rem @padding;
    > h1 {
      flex: 1;
      text-align: center;
      color: @textColor;
      font-size: @titleFont;
    }
    > i {
      width: @icon;
      height: @icon;
      background: url("./img/back.png") no-repeat;
      background-size: 100%;
      vertical-align: middle;
    }
    .out-wrap {
      width: .8rem;
      height: .8rem;
    }
  }
  .header.light{
    > h1{
      color: white;
    }
    >i{
      background: url("./img/back_light.png") no-repeat;
      background-size: 100%;
    }
  }
</style>
<template>
  <div>
    <div class="header" :class="[setStyle]">
      <i v-show="backFlag" @click="back" ></i>
      <h1 v-text="pageTitle" ></h1>
      <div class="out-wrap">
        <more v-if="showMore" :productType="productType" :setStyle="setStyle" :showLoginSlide="showLoginSlide" :propConfig='propConfig'></more>
      </div>
    </div>
  </div>
</template>
<script>
  import more from './more.vue'
  import {mapState} from 'vuex'
  export default {
    data(){
      return{
        backFlag: true
      }
    },
    watch:{
      $route (obj){
        this.backFlag = !(obj.meta && obj.meta.hideBack)
      }
    },
    props:{
      reportData:{
        type:Object,
        default(){
          return {}
        }
      },
      stopBack:Boolean,
      productType:Number,
      setStyle:String,
      showMore:{
        type:Boolean,
        default: true
      },
      showLoginSlide: {
        type:Boolean,
        default: true
      },
      propConfig: {
        type:Object,
        default(){
          return {}
        }
      }
    },
    mounted(){
      this.backFlag = !(this.$route.meta && this.$route.meta.hideBack)
    },
    computed:{
      ...mapState(['pageTitle'])
    },
    methods:{
      back(){
        this.$emit('back');
        if(!this.stopBack){
          this.$router.back();
        }
        if(this.reportData.back){
          this.report(this.reportData.back)
        }
      }
    },
    components:{
      more
    }
  }

</script>
